import React from "react";

const prices = [
  { title: "2 Helfer", price: " 99 €", dur: "2 Std.", bullets: ["Tragen/Beladen", "Ein-/Auspacken"] },
  { title: "2 Helfer + Transporter", price: "200 €", dur: "2 Std.", bullets: ["bis 20 m³", "An-/Abfahrt inkl.", "Versicherung"], featured: true },
  { title: " Mehr als 2 Helfer + Transporter", price: "auf Anfrage", dur: "—", bullets: ["großes Ladevolumen", "Profi-Ausstattung"] },
];

export default function Prices() {
  return (
    <section id="preise" className="py-10 md:py-16 bg-white">
      <div className="max-w-[1100px] mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold">Preise (ab)</h2>

        {/* Horizontal scroll on mobile */}
        <div className="mt-5 -mx-4 px-4 overflow-x-auto md:overflow-visible snap-x snap-mandatory md:snap-none flex md:grid md:grid-cols-3 gap-4">
          {prices.map((p) => (
            <div
              key={p.title}
              className={`min-w-[80%] sm:min-w-[60%] md:min-w-0 snap-start rounded-2xl p-6 shadow-[0_10px_25px_rgba(2,6,23,.06)] ${p.featured ? "ring-2 ring-[#FF6B00]" : ""}`}
            >
              <div className="font-semibold text-lg">{p.title}</div>
              <div className="mt-2 flex items-baseline gap-2">
                <div className="text-3xl font-extrabold text-[#FF6B00]">
                  {p.title === "2 Helfer" ? "79,20 €" : p.title === "2 Helfer + Transporter" ? "160 €" : p.price}
                </div>
                {p.title !== " Mehr als 2 Helfer + Transporter" && (
                  <span className="text-sm text-slate-400 line-through">{p.price}</span>
                )}
              </div>
              {p.title === " Mehr als 2 Helfer + Transporter" && (
                <div className="mt-1 text-sm font-semibold text-[#FF6B00]">20 % Rabatt auf Anfrage</div>
              )}
              <div className="text-sm opacity-70">{p.dur}</div>
              <ul className="mt-4 text-sm text-slate-600 space-y-2 list-disc list-inside">
                {p.bullets.map((b) => <li key={b}>{b}</li>)}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-xs text-slate-500 mt-4">* Alle Preise enthalten bereits 20 % Rabatt. Beispielpreise; exaktes Angebot nach Besichtigung/Angaben.</p>
      </div>
    </section>
  );
}
